import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Clock, Globe, Facebook, Instagram, Youtube } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
// Custom TikTok icon since it's not in standard lucide-react
const TikTokIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-592">
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" data-id="element-593" />
  </svg>;
export function ContactDetails() {
  return <section className="py-20 bg-brand-cream relative" data-id="element-594">
      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-595">
        <SectionHeading title="Date de Contact" data-id="element-596" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-597">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-[32px] p-8 shadow-warm" data-id="element-598">
            <h3 className="text-2xl font-bold text-brand-text mb-2" data-id="element-599">
              Adrian Huniade
            </h3>
            <p className="text-brand-gold font-medium mb-8 text-sm uppercase tracking-wider" data-id="element-600">
              Instructor Internațional Theta Healing® • Facilitator Heal Your
              Life • Consilier Dezvoltare Personală
            </p>

            <div className="space-y-6" data-id="element-601">
              <div className="flex items-center gap-4" data-id="element-602">
                <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center text-brand-gold shrink-0" data-id="element-603">
                  <Phone className="w-5 h-5" data-id="element-604" />
                </div>
                <div data-id="element-605">
                  <p className="text-sm text-brand-textSec mb-1" data-id="element-606">Telefon</p>
                  <a href="tel:+40726042604" className="text-lg font-semibold text-brand-text hover:text-brand-gold transition-colors" data-id="element-607">
                    +40 726 042 604
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-608">
                <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center text-brand-gold shrink-0" data-id="element-609">
                  <Mail className="w-5 h-5" data-id="element-610" />
                </div>
                <div data-id="element-611">
                  <p className="text-sm text-brand-textSec mb-1" data-id="element-612">Email</p>
                  <a href="mailto:academia.abundentei365@gmail.com" className="text-lg font-semibold text-brand-text hover:text-brand-gold transition-colors break-all" data-id="element-613">
                    academia.abundentei365@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-4" data-id="element-614">
                <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center text-brand-gold shrink-0" data-id="element-615">
                  <Clock className="w-5 h-5" data-id="element-616" />
                </div>
                <div data-id="element-617">
                  <p className="text-sm text-brand-textSec mb-1" data-id="element-618">Program</p>
                  <p className="text-lg font-semibold text-brand-text" data-id="element-619">
                    Marți - Vineri: 09:00 - 14:00
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-white rounded-[32px] p-8 shadow-warm flex flex-col justify-between" data-id="element-620">
            <div data-id="element-621">
              <h3 className="text-xl font-bold text-brand-text mb-6" data-id="element-622">
                Social Media
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-623">
                <a href="https://www.facebook.com/share/18D8cz1N2t/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-4 rounded-xl bg-brand-cream hover:bg-brand-gold/10 transition-colors group" data-id="element-624">
                  <Facebook className="w-5 h-5 text-[#1877F2] group-hover:scale-110 transition-transform" data-id="element-625" />
                  <span className="font-medium text-brand-text" data-id="element-626">Facebook</span>
                </a>
                <a href="https://instagram.com/academia_de_abundenta" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-4 rounded-xl bg-brand-cream hover:bg-brand-gold/10 transition-colors group" data-id="element-627">
                  <Instagram className="w-5 h-5 text-[#E4405F] group-hover:scale-110 transition-transform" data-id="element-628" />
                  <span className="font-medium text-brand-text" data-id="element-629">Instagram</span>
                </a>
                <a href="https://youtube.com/@academiadeabundenta?si=hH71WCz3OzEx7gan" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-4 rounded-xl bg-brand-cream hover:bg-brand-gold/10 transition-colors group" data-id="element-630">
                  <Youtube className="w-5 h-5 text-[#FF0000] group-hover:scale-110 transition-transform" data-id="element-631" />
                  <span className="font-medium text-brand-text" data-id="element-632">YouTube</span>
                </a>
                <a href="https://www.tiktok.com/@academia.de.abund" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 p-4 rounded-xl bg-brand-cream hover:bg-brand-gold/10 transition-colors group" data-id="element-633">
                  <TikTokIcon className="w-5 h-5 text-black group-hover:scale-110 transition-transform" data-id="element-634" />
                  <span className="font-medium text-brand-text" data-id="element-635">TikTok</span>
                </a>
              </div>
            </div>

            <div data-id="element-636">
              <h3 className="text-xl font-bold text-brand-text mb-4" data-id="element-637">
                Website Partener
              </h3>
              <a href="https://www.luminaabundentei.ro" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 p-4 rounded-xl border-2 border-brand-cream hover:border-brand-gold/30 transition-colors group" data-id="element-638">
                <div className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center text-brand-gold group-hover:bg-brand-gold group-hover:text-white transition-colors" data-id="element-639">
                  <Globe className="w-5 h-5" data-id="element-640" />
                </div>
                <span className="font-medium text-brand-text text-lg" data-id="element-641">
                  www.luminaabundentei.ro
                </span>
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}